module.exports = __webpack_public_path__ + "sit/20260507162559/img/service.edbff227.png";